export default __webpack_public_path__ + "static/media/HostingCloudLandingPage.875c63c8.jpeg";